module.exports = {"name":"Článok - detail udalosti","defaultData":[{"data":{},"meta":{"name":"event-detail","pageBlockId":1},"options":{}},{"data":{},"meta":{"name":"registration-form-zosr","pageBlockId":4},"options":{}}]}


//////////////////
// WEBPACK FOOTER
// ./data/portal2/templates/article-event/article-event.json
// module id = 279
// module chunks = 0